import { getAssetPath } from "@stencil/core";
import { MapStyles, switchMapStyles } from "@utils/map";

export default class MapToggleControl implements mapboxgl.IControl {
	private _map: mapboxgl.Map;
	private _container: HTMLDivElement;
	satelliteViewActivated = false;
	icon: HTMLImageElement;
	toggleButton: HTMLButtonElement;

	private mapStyleToggle() {
		this.satelliteViewActivated = !this.satelliteViewActivated;
		const styleID = this.satelliteViewActivated
			? MapStyles.satellite
			: MapStyles.roadmap;

		this.icon.src = getAssetPath(
			this.satelliteViewActivated
				? "assets/map-view.svg"
				: "assets/satellite-view.svg",
		);

		switchMapStyles(styleID, this._map);
	}

	// create a DOM element for the control
	createControlElement() {
		this.toggleButton = document.createElement("button");
		this.toggleButton.type = "button";
		this.toggleButton.title = "Toggle between satellite and map views.";
		this.toggleButton.id = "satellite-toggle-button";
		this.toggleButton.onclick = () => this.mapStyleToggle();

		this.icon = document.createElement("img");
		this.icon.src = getAssetPath("assets/satellite-view.svg");
		this.icon.alt = "Map view icon";
		this.icon.classList.add("mapboxgl-ctrl-icon-modified");
		this.icon.width = 20;
		this.icon.height = 20;
		this.toggleButton.appendChild(this.icon);

		return this.toggleButton;
	}

	onAdd(map: mapboxgl.Map) {
		this._map = map;
		this._container = document.createElement("div");
		this._container.className =
			"mapboxgl-ctrl mapboxgl-ctrl-toggle mapboxgl-ctrl-group";
		this._container.appendChild(this.createControlElement());
		return this._container;
	}

	onRemove() {
		this._container.parentNode.removeChild(this._container);
		this._map = undefined;
	}
}
